<template>
  <div class="info-progress-wrapper">
    <div class="progress-circle-container">
      <svg class="progress-circle" width="24" height="24" viewBox="0 0 24 24">
        <circle class="progress-circle-bg" cx="12" cy="12" r="10" fill="none" stroke-width="2" />
        <circle class="progress-circle-value" cx="12" cy="12" r="10" fill="none" stroke-width="2" :style="{ strokeDashoffset: progressOffset }" />
      </svg>
      <span class="info-icon">i</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoProgressCircle',
  props: {
    progressOffset: { type: Number, default: 62.8 },
    backgroundColor: { type: String, default: '#337ab7' }
  },
  mounted() { this.updateBackgroundColorVar(); },
  watch: {
    backgroundColor: { handler() { this.updateBackgroundColorVar(); }, immediate: true }
  },
  methods: {
    updateBackgroundColorVar() {
      const bgColor = this.backgroundColor;
      document.documentElement.style.setProperty('--header-bg-color', bgColor);
      document.documentElement.style.setProperty('--header-hover-bg-color', this.calculateDarkenedColor(bgColor));
      document.documentElement.style.setProperty('--header-base-color', bgColor);
    },
    calculateDarkenedColor(color) {
      let darkenedColor = 'rgb(25, 80, 129)';
      try {
        if (color.startsWith('#')) {
          const r = parseInt(color.slice(1, 3), 16), g = parseInt(color.slice(3, 5), 16), b = parseInt(color.slice(5, 7), 16);
          darkenedColor = 'rgb(' + Math.round(r * 0.85) + ',' + Math.round(g * 0.944) + ',' + Math.round(b * 0.973) + ')';
        } else if (color.startsWith('rgb')) {
          const m = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
          if (m) darkenedColor = 'rgb(' + Math.round(m[1] * 0.85) + ',' + Math.round(m[2] * 0.944) + ',' + Math.round(m[3] * 0.973) + ')';
        }
      } catch (e) { console.error('Error calculating darkened color:', e); }
      return darkenedColor;
    }
  }
}
</script>

<style>
.info-progress-wrapper { position: absolute; right: 7px; top: 68%; transform: translateY(-50%); display: flex; align-items: center; justify-content: center; z-index: 1; }
.progress-circle-container { position: relative; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; }
.progress-circle-container::before { content: ""; position: absolute; width: 30px; height: 30px; background-color: var(--header-hover-bg-color, var(--header-base-color, #337ab7)); opacity: 1; border-radius: 50%; filter: blur(5px); z-index: -1; }
.progress-circle { transform: rotate(-90deg); }
.progress-circle-bg { stroke: rgba(255, 255, 255, 0.3); }
.progress-circle-value { stroke: white; stroke-dasharray: 62.8; stroke-dashoffset: 62.8; transition: stroke-dashoffset 0.1s linear; }
.info-icon { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 14px; font-weight: bold; color: white; font-style: italic; }
</style>
